<span id="mathContent" [innerHTML]="content"></span>
